import { MarketerProduct } from '../../../typings/marketers';

export const UPDATE_INTERNAL_MARKETER_EDIT_PRODUCT = 'UPDATE_INTERNAL_MARKETER_EDIT_PRODUCT';
export type UPDATE_INTERNAL_MARKETER_EDIT_PRODUCT = typeof UPDATE_INTERNAL_MARKETER_EDIT_PRODUCT;

export interface UpdateInternalMarketerEditProduct {
    type: UPDATE_INTERNAL_MARKETER_EDIT_PRODUCT;
    product: Partial<MarketerProduct>;
}

export function updateInternalMarketerEditProductAction(
    product: Partial<MarketerProduct>
): UpdateInternalMarketerEditProduct {
    return {
        type: UPDATE_INTERNAL_MARKETER_EDIT_PRODUCT,
        product
    };
}
